export default __webpack_public_path__ + "static/media/img_company_header26.44f50cc2.png";